export const normalizeArray = (data) =>
  Array.isArray(data)
    ? data
    : data && typeof data === 'object'
      ? Object.values(data).filter(item => typeof item === 'object' && item !== null && !Array.isArray(item))
      : [];